module.exports = __webpack_public_path__ + "img/sell-car1024x576.f6a1d787.png";